import Page, { EPageVariant } from 'ui/Page/Page';
import classes from './statis.module.scss';

export default function Policy() {
    return (
        <Page variant={EPageVariant.WEB} header footer>
            <h3 className={classes.H3}>Политика конфиденциальности</h3>
            <p>
            Последнее обновление: 10 июня 2026 года.
            </p>
            <h4>I. Общие положения</h4>
            <p>
            Настоящая Политика конфиденциальности определяет порядок обработки персональных данных пользователей веб-сайта
            <a href='https://flearn.net'> flearn.net</a> (далее — «Сайт»).
            </p>

            <p>
            Политика применяется ко всей информации, которую Оператор может получить о пользователях при использовании Сайта.
            </p>

            <ol>
                <li>
                    Оператором персональных данных является Ulianova Sofiia (далее — «Оператор»).
                </li>
                <li>
                    Оператор уважает право пользователей на неприкосновенность частной жизни и принимает разумные меры для защиты персональных данных.
                </li>
                <li>
                    Настоящая Политика применяется ко всем пользователям Сайта независимо от их места проживания или гражданства.
                </li>
                <li>
                    Используя Сайт, пользователь подтверждает ознакомление с настоящей Политикой и соглашается с ее условиями.
                </li>
                <li>
                    Если пользователь не согласен с условиями настоящей Политики, он должен прекратить использование Сайта.
                </li>
            </ol>

            <h4>II. Основные понятия, используемые в Политике</h4>

            <ol>
                <li>
                    Персональные данные — любая информация, относящаяся прямо или косвенно к определенному или определяемому пользователю Сайта.
                </li>
                <li>
                    Пользователь — любое лицо, использующее Сайт.
                </li>
                <li>
                    Обработка персональных данных — любое действие или совокупность действий с персональными данными, включая сбор, запись, систематизацию, хранение, использование, передачу, изменение, удаление и уничтожение данных.
                </li>
                <li>
                    Автоматизированная обработка персональных данных — обработка данных с использованием вычислительной техники.
                </li>
                <li>
                    Оператор — физическое лицо, самостоятельно определяющее цели и способы обработки персональных данных.
                </li>
                <li>
                    Cookie-файлы — небольшие файлы, сохраняемые на устройстве пользователя для обеспечения работы отдельных функций Сайта.
                </li>
                <li>
                    Обезличенные данные — данные, которые не позволяют прямо идентифицировать конкретного пользователя.
                </li>
                <li>
                    Трансграничная передача персональных данных — передача персональных данных за пределы государства, в котором они были собраны.
                </li>
            </ol>

            <h4>III. Оператор может обрабатывать следующие персональные данные Пользователя</h4>

            <ol>
                <li>
                    Имя пользователя.
                </li>
                <li>
                    Адрес электронной почты.
                </li>
                <li>
                    Идентификатор учетной записи Google.
                </li>
                <li>
                    Информацию профиля, предоставляемую сервисами Google в рамках авторизации пользователя.
                </li>
                <li>
                    IP-адрес пользователя.
                </li>
                <li>
                    Информацию о браузере, устройстве и операционной системе.
                </li>
                <li>
                    Данные файлов cookie и аналогичных технологий.
                </li>
                <li>
                    Контент, публикуемый пользователем на Сайте.
                </li>
                <li>
                    Сообщения и обращения, направляемые пользователем через функциональность Сайта.
                </li>
                <li>
                    Технические журналы работы Сайта и сведения об использовании функциональности Сайта.
                </li>
                <li>
                    Обезличенные данные о посещении Сайта, собираемые сервисами веб-аналитики, включая Google Analytics.
                </li>
            </ol>

            <h4>IV. Цели обработки персональных данных</h4>

            <ol>
                <li>
                    Создание и обслуживание учетных записей пользователей.
                </li>
                <li>
                    Предоставление пользователям доступа к функциональности Сайта.
                </li>
                <li>
                    Обеспечение работы личного кабинета пользователя.
                </li>
                <li>
                    Хранение, публикация и отображение пользовательского контента.
                </li>
                <li>
                    Обеспечение безопасности Сайта и предотвращение злоупотреблений.
                </li>
                <li>
                    Рассмотрение обращений пользователей и предоставление ответов на такие обращения.
                </li>
                <li>
                    Анализ использования Сайта и улучшение его работы.
                </li>
                <li>
                    Выявление технических ошибок и обеспечение стабильной работы Сайта.
                </li>
                <li>
                    Защита законных интересов Оператора и пользователей Сайта.
                </li>
            </ol>

            <h4>V. Правовые основания обработки персональных данных</h4>

            <ol>
                <li>
                    Обработка персональных данных осуществляется на основании согласия пользователя, выраженного путем использования Сайта либо предоставления персональных данных через функциональность Сайта.
                </li>
                <li>
                    Обработка персональных данных может осуществляться в случаях, когда она необходима для предоставления пользователю функциональности Сайта.
                </li>
                <li>
                    Обработка персональных данных может осуществляться в целях законного интереса Оператора, связанного с обеспечением безопасности, работоспособности и развития Сайта.
                </li>
                <li>
                    Использование файлов cookie и сервисов аналитики осуществляется в объеме, необходимом для обеспечения работы Сайта и анализа его использования.
                </li>
            </ol>
            <h4>VI. Порядок сбора, хранения и защиты персональных данных</h4>

            <p>
            Оператор принимает разумные организационные и технические меры для защиты персональных данных пользователей от несанкционированного доступа, изменения, раскрытия, уничтожения или иных неправомерных действий.
            </p>

            <ol>
                <li>
                    Персональные данные обрабатываются только в объеме, необходимом для достижения целей, указанных в настоящей Политике.
                </li>
                <li>
                    Доступ к персональным данным предоставляется только лицам и сервисам, которым такой доступ необходим для обеспечения работы Сайта.
                </li>
                <li>
                    Оператор принимает меры по защите персональных данных от случайной утраты, неправомерного использования и несанкционированного доступа.
                </li>
                <li>
                    Пользователь вправе обратиться к Оператору для уточнения, исправления или удаления своих персональных данных.
                </li>
                <li>
                    Персональные данные хранятся до достижения целей их обработки либо до получения запроса пользователя на удаление данных, если иное не требуется законодательством или техническими потребностями обеспечения работы Сайта.
                </li>
            </ol>

            <h4>VII. Использование сервисов Google</h4>

            <ol>
                <li>
                    Для авторизации пользователей Сайт использует сервис Google Authentication.
                </li>
                <li>
                    При использовании входа через Google Сайт может получать данные профиля пользователя, предоставляемые Google в рамках выбранных пользователем настроек доступа.
                </li>
                <li>
                    Используя авторизацию через Google, пользователь соглашается с условиями использования сервисов Google и политикой конфиденциальности Google.
                </li>
                <li>
                    Сайт не получает и не хранит пароль пользователя от учетной записи Google.
                </li>
            </ol>

            <h4>VIII. Использование сервисов аналитики</h4>

            <ol>
                <li>
                    Для анализа использования Сайта могут применяться сервисы веб-аналитики, включая Google Analytics.
                </li>
                <li>
                    Сервисы аналитики могут собирать обезличенную информацию о действиях пользователей на Сайте.
                </li>
                <li>
                    Полученная аналитическая информация используется исключительно для улучшения качества работы Сайта, выявления технических проблем и анализа востребованности функциональности.
                </li>
            </ol>

            <h4>IX. Передача персональных данных третьим лицам</h4>

            <ol>
                <li>
                    Оператор не продает и не предоставляет персональные данные пользователей третьим лицам для маркетинговых целей.
                </li>
                <li>
                    Персональные данные могут передаваться поставщикам технических сервисов, обеспечивающим работу Сайта, включая:
                    <ul>
                        <li>сервисы авторизации;</li>
                        <li>провайдеров хостинга;</li>
                        <li>аналитические сервисы;</li>
                        <li>сервисы мониторинга и обеспечения безопасности.</li>
                    </ul>
                </li>
                <li>
                    Передача данных государственным органам осуществляется исключительно в случаях, предусмотренных применимым законодательством.
                </li>
            </ol>

            <h4>X. Трансграничная передача персональных данных</h4>

            <ol>
                <li>
                    В связи с использованием международных облачных и технических сервисов персональные данные могут обрабатываться за пределами Республики Сербия.
                </li>
                <li>
                    Оператор принимает разумные меры для обеспечения надлежащего уровня защиты персональных данных при такой обработке.
                </li>
                <li>
                    Используя Сайт, пользователь соглашается с возможностью трансграничной обработки данных в объеме, необходимом для функционирования Сайта.
                </li>
            </ol>

            <h4>XI. Права пользователя</h4>

            <ol>
                <li>
                    Пользователь вправе запросить информацию о своих персональных данных, обрабатываемых Оператором.
                </li>
                <li>
                    Пользователь вправе потребовать исправления неточных или устаревших данных.
                </li>
                <li>
                    Пользователь вправе потребовать удаления своих персональных данных.
                </li>
                <li>
                    Пользователь вправе отозвать ранее предоставленное согласие на обработку персональных данных.
                </li>
                <li>
                    Пользователь вправе ограничить обработку своих данных в случаях, предусмотренных применимым законодательством.
                </li>
            </ol>

            <h4>XII. Использование файлов Cookie</h4>

            <ol>
                <li>
                    Сайт использует файлы cookie и аналогичные технологии для обеспечения корректной работы сервисов.
                </li>
                <li>
                    Cookie могут использоваться для поддержания авторизации пользователя, хранения пользовательских настроек, анализа посещаемости и повышения удобства использования Сайта.
                </li>
                <li>
                    Пользователь может ограничить использование cookie через настройки своего браузера, однако это может повлиять на доступность отдельных функций Сайта.
                </li>
            </ol>

            <h4>XIII. Контактная информация</h4>

            <ol>
                <li>
                    По вопросам обработки персональных данных пользователь может обратиться к Оператору по адресу электронной почты: ulianova.sofia@gmail.com.
                </li>
                <li>
                    Оператором персональных данных является:
                    <br />
                    <strong>Ulianova Sofiia</strong>
                    <br />
                    Республика Сербия
                    <br />
                    E-mail: ulianova.sofia@gmail.com
                </li>
            </ol>

            <h4>XIV. Заключительные положения</h4>

            <ol>
                <li>
                    Настоящая Политика может быть изменена Оператором в любое время без предварительного уведомления пользователей.
                </li>
                <li>
                    Новая редакция Политики вступает в силу с момента ее публикации на Сайте.
                </li>
                <li>
                    Продолжение использования Сайта после публикации новой редакции Политики означает согласие пользователя с внесенными изменениями.
                </li>
                <li>
                    Актуальная версия Политики размещается по адресу:
                    <a href='https://flearn.net/policy'> https://flearn.net/policy</a>.
                </li>
            </ol>
        </Page>
    );
}
